module.exports = __webpack_public_path__ + "img/bg-summary-card-yellow.0557c44a.svg";